(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('SingleWipDialogController', SingleWipDialogController);

    SingleWipDialogController.$inject = ['$uibModalInstance', 'entity', 'AlertRules'];

    function SingleWipDialogController ($uibModalInstance, entity, AlertRules) {
        var vm = this;

        vm.warning = entity;
        vm.clear = clear;
        vm.confirm = confirm;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm () {
            AlertRules.wipAlerts({warning: vm.warning.warningId, wip:vm.warning.wip ? 1 : 0, objectUniqueCode:vm.warning.objectUniqueCode}, onSuccess, onError);
        }

        function onSuccess() {
            vm.warning.wip = !vm.warning.wip;
            $uibModalInstance.close(true);
        }

        function onError() {

        }
    }
})();
